import { render, staticRenderFns } from "./GenericoView.vue?vue&type=template&id=48e06677"
import script from "./GenericoView.vue?vue&type=script&lang=ts"
export * from "./GenericoView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports